import { RequestPolicy, useQuery } from 'urql';
import { graphql } from '~/gql';
import { ContactsQuery, Status } from '~/gql/graphql';

export type Contact = ContactsQuery['contacts'][number];

const ContactsDocument = graphql(`
  query Contacts($status: [Status!], $relationship: [String!]) {
    contacts(status: $status, relationship: $relationship) {
      id
      status
      type
      name
      email
      phone
      relationship
      image
      isCurrentUser
      isTeamMember
    }
  }
`);

export function useContacts({
  includeInactive = false,
  requestPolicy = 'cache-and-network',
  pause = false,
}: {
  includeInactive?: boolean;
  requestPolicy?: RequestPolicy;
  pause?: boolean;
} = {}): Contact[] {
  const [result] = useQuery({
    query: ContactsDocument,
    variables: {
      status: includeInactive
        ? [Status.Active, Status.Inactive]
        : [Status.Active],
    },
    requestPolicy,
    pause,
  });

  return result.data?.contacts ?? [];
}
